export const BOTTLE_CONDITIONS = [
  'bottles_page.conditions.star_on_tickets_exchange',
  'bottles_page.conditions.max_stars',
  'bottles_page.conditions.advertising_on_ticket_exchange',
  'bottles_page.conditions.max_advertising',
]
